/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

import moment from 'moment';

//"#00acc1"

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import Chat from 'components/Chat';
import Items from './EditFreight.jsx';
// import EditPartyDateDetails from './EditPartyDateDetails.jsx';
import ModalPartyDetails from './ModalPartyDetails.jsx';
import ModalEditPartyDateDetails from './ModalEditPartyDateDetails.jsx';

const Transition = (props) => {
  return <Slide direction="down" {...props} />;
};

const useStyles = makeStyles((theme) => ({
  button: {
    color: 'white',
    backgroundColor: '#00acc1',
  },
}));

const PartyFreightSummary = (props) => {
  const {
    dispatch,
    orderID,
    orderData,
    origin,
    destination,
    classes,
    thirdParty,
    deliveryType,
    items,
    air,
    airWaybillNumber,
    serviceLevel,
    additionalLegs,
    flight,
    cargoAir,
    serviceETA,
    ground,
    ltl,
    shipperName,
    billingParty,
    itemCount,
    isEditable,
    chat,
    openChats,
    openChat,
    handleClickOpen,
    handleClose,
    businessQuery,
    userQuery,
    errorMessage,
    assignBusiness,
    onAssignPic,
    removePicture,
    assignUser,
    handleChange,
    handleArrChange,
    handleSelectChange,
    handleItemSelectChange,
    handleDateChange,
    handleToggleServices,
    handleNotificationsToggle,
    saveInfo,
    addItem,
    removeItem,
    handleItemChange,
    handleToggleItemServices,
    handleSelectChangeObj,
    toggleFootage,
    saveFreight,
    updateOrigin,
    updateDestination,
    updateThirdParty,
    updateFreight,
  } = props;

  const [totalWeight, setTotalWeight] = useState(0);
  const styles = useStyles();

  let localDate;
  if (!(origin.date instanceof Date)) {
    localDate = origin.date.toDate();
  } else {
    localDate = origin.date;
  }

  let localDateDestination;
  if (!(destination.date instanceof Date)) {
    localDateDestination = destination.date.toDate();
  } else {
    localDateDestination = destination.date;
  }

  // Keep track of total weight
  useEffect(() => {
    let weight = 0;
    for (let i = 0; i < items.length; i++) {
      const wpp = parseInt(items[i].weight ? items[i].weight : 0);
      const qty = parseInt(items[i].quantity ? items[i].quantity : 0);
      weight += wpp * qty;
    }
    if (weight !== totalWeight) setTotalWeight(weight);
  });

  return (
    <Grid container xs={12} className={styles.root}>
      <Grid item xs={12}>
        <div
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0)',
          }}
        >
          <Grid item xs={12}>
            Shipment Initiated By: {shipperName}
            <h4>
              <b>Shipper</b>
            </h4>
            <b style={{ size: '1.2em' }}>
              {billingParty == 'Shipper' && (
                <div style={{ color: 'green', display: 'inline' }}>$ </div>
              )}
              {/* {orderData.clone ? origin['businessName'] : <Link to={`/shipper/${origin['entityID']}`}>{origin['businessName']} | KSMS: {origin['ksms'] ? "TRUE" : "FALSE"}</Link>} */}
              {origin['businessName']}
              <br />
            </b>
            <b>Shipper ID:</b>
            <Link
        to={{
          pathname: `/shipper/${origin['entityID']}`
        }}
      >{origin['entityID']}</Link>
            <p>
              <b>Reference ID:</b>{' '}
              {origin['referenceID'] && ` ${origin['referenceID']}`}
            </p>
            <b>
              <p>ORIGIN ADDRESS:</p>
            </b>
            <p>
              {origin['address']}
              <br />
              {origin['city']} {origin['state']}
              <br />
              {origin['zip']}
            </p>
          </Grid>
          <Grid alignItems xs={12}>
            <b>
              <p>Contact Info : </p>
            </b>
            <p>
              {`${origin['firstName']} ${origin['lastName']}`} |{' '}
              {origin['phone']} | {origin['email']}
            </p>
          </Grid>
          <Grid item xs={12}>
            {/* {console.log(origin.date)} */}
            {!dispatch ? (
              <div>
                <b>
                  <p>Pick Up :</p>
                </b>
                {origin.startTimeWindow ? (
                  <p>
                    {`${moment(localDate).format('MM-DD-YYYY')} at ${
                      origin['startTimeWindow']
                    } - ${origin['endTimeWindow']}`}
                  </p>
                ) : (
                  <p>{`${moment(localDate).format('MM-DD-YYYY HH:mm')}`}</p>
                )}
              </div>
            ) : (
              <div>
                <b>
                  <p>Pick Up :</p>
                </b>
                {origin.startTimeWindow ? (
                  <p>
                    {` ${moment(localDate).format('MM-DD-YYYY')} at ${
                      origin['startTimeWindow']
                    } - ${origin['endTimeWindow']}`}
                  </p>
                ) : (
                  <p>{`${moment(localDate).format('MM-DD-YYYY')}`}</p>
                )}
              </div>
            )}
          </Grid>
          <Grid item xs={12}>
            <p>{origin.services.map((service) => `${service} | `)}</p>
          </Grid>
          <Grid item xs={12}>
            <p>Custom Extra Service: {origin['customExtraService']}</p>
          </Grid>
          <Grid item xs={12} style={{ display: 'flex' }}>
            {isEditable && (
              <Button
                style={{
                  backgroundColor: '#00acc1',
                  color: '#FFF',
                  marginRight: 15,
                  maxHeight: 36,
                }}
                variant="contained"
                onClick={() => handleClickOpen('updateOrigin')}
              >
                EDIT ORIGIN
              </Button>
            )}
            <Button
              style={{
                backgroundColor: '#00acc1',
                color: '#FFF',
                maxHeight: 36,
              }}
              variant="contained"
              onClick={() => openChat('origin')}
            >
              OPEN ORIGIN CHAT
            </Button>
          </Grid>
          {chat && (
            <Grid item>
              {openChats.indexOf('origin') > -1 && (
                <Chat orderID={orderID} channel="origin" />
              )}
            </Grid>
          )}
        </div>
      </Grid>

      <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
        <Divider orientation="horizontal" variant="fullWidth" />
      </Grid>

      <Grid item xs={12}>
        <div>
          <Grid item xs={12}>
            <h4>
              <b>Consignee</b>
            </h4>
            <p>
              <b>
                {billingParty == 'Consignee' && (
                  <div style={{ color: 'green', display: 'inline' }}>$ </div>
                )}
                {/* <Link to={`/shipper/${destination['entityID']}`}>{destination['businessName']} | KSMS: {destination['ksms'] ? "TRUE" : "FALSE"}</Link> */}
                {/* {orderData.clone ? destination['businessName'] : <Link to={`/destination/${origin['entityID']}`}>{destination['businessName']} | KSMS: {destination['ksms'] ? "TRUE" : "FALSE"}</Link>} */}
                {destination['businessName']}
                <br />
                {destination['entityID']}
              </b>
            </p>
            <p>
              {destination['referenceID'] && ` ${destination['referenceID']}`}
            </p>
            <p>
              <b>DESTINATION ADDRESS</b>
            </p>
            <p>
              {destination['address']}
              <br />
              {destination['city']} {destination['state']}
              <br />
              {destination['zip']}
            </p>
          </Grid>
          <Grid item xs={12}>
            <p>
              {`${destination['firstName']} ${destination['lastName']}`} |{' '}
              {destination['phone']} | {destination['email']}
            </p>
          </Grid>
          {orderData &&
                      <Grid item xs={12}>
                        {!orderData.deliveryType &&
                        (  <div>
                          <b>
                            <p>Deliver By :</p>
                          </b>
                          {destination.startTimeWindow ? (
                            <p>
                              {`${moment(localDateDestination).format('MM-DD-YYYY')} at ${
                                destination['startTimeWindow']
                              } - ${destination['endTimeWindow']}`}
                            </p>
                          ) : (
                            <p>{`${moment(localDateDestination).format('MM-DD-YYYY HH:mm')}`}</p>
                          )}
                        </div>)
                      }
                      {orderData.deliveryType == "Air" && (
                      <div>
                        {orderData.origin.deliverBy &&
                        <p> 
                          Deliver By{" "}
                          {moment(orderData.origin.deliverBy.toDate()).format("MM/DD/YYYY")} {([orderData.air ? orderData.air.start : null, orderData.air ? orderData.air.end : null].filter(Boolean).join(' - '))}
                        </p>}
                        <p>Airline Waybill #: {orderData.airWaybillNumber}</p>
                        <p>Service Level: {orderData.serviceLevel}</p>
                        {orderData.flight &&
                        <p>
                        {orderData.additionalLegs
                          ? `Flight 1: ${orderData.flight.number}`
                          : `Flight: ${orderData.flight.number}`}
                        <br />
                        {orderData.additionalLegs ? `Flight 2: ${orderData.additionalLegs[0].number}` : ` `}
                      </p>
                        }
                      </div>
                    )}
                    {orderData.deliveryType == "Scheduled Air" && (
                      <div>
                        <p>
                          Deliver By{" "}
                          {orderData.origin.deliverBy && moment(orderData.origin.deliverBy.toDate()).format("MM/DD/YYYY")} {([orderData.cargoAir ? orderData.cargoAir.start : null, orderData.cargoAir ? orderData.cargoAir.end : null].filter(Boolean).join(' - '))}
                        </p>
                        <p>Airline Waybill #: {orderData.airWaybillNumber}</p>
                        <p>Service Level: {orderData.serviceLevel}</p>
                      </div>
                    )}
                    {orderData.deliveryType == "Ground" && (
                      <p>
                        Deliver By {moment(orderData.serviceETA.toDate()).format("MM/DD/YYYY")} {([orderData.ground ? orderData.ground.start : null, orderData.ground ? orderData.ground.end : null].filter(Boolean).join(' - '))}
                      </p>
                    )}
                    {console.log(orderData.deliveryType)}
                    {orderData.deliveryType == "Additional Options" && (
                      <p>
                        Deliver By {moment(orderData.serviceETA.toDate()).format("MM/DD/YYYY")} {([orderData.ltl ? orderData.ltl.start : null, orderData.ltl ? orderData.ltl.end : null].filter(Boolean).join(' - '))}
                      </p>
                    )}
                        {/* <p>
                          {// `Drop off ${moment(destination.date.toDate()).format('MM-DD-YYYY')} at ${destination['startTimeWindow']} - ${destination['endTimeWindow']}`
                          `Drop off ${
                            destination.date instanceof Date
                              ? moment(destination.date).format('MM/DD/YYYY') +
                                ' ' +
                                `${destination['startTimeWindow']} - ${destination['endTimeWindow']}`
                              : moment(destination.date.toDate()).format('MM/DD/YYYY') +
                                ' ' +
                                `${destination['startTimeWindow']} - ${destination['endTimeWindow']}`
                          }`}
                        </p> */}
                      </Grid>
                    
          
          }

          <Grid item xs={12}>
            <p>{destination.services.map((service) => `${service} | `)}</p>
          </Grid>
          <Grid item xs={12}>
            <p>Custom Extra Service: {destination['customExtraService']}</p>
          </Grid>
          <Grid item xs={12} style={{ display: 'flex' }}>
            {isEditable && (
              <Button
                style={{
                  backgroundColor: '#00acc1',
                  color: '#FFF',
                  marginRight: 15,
                }}
                onClick={() => handleClickOpen('updateDestination')}
              >
                EDIT DESTINATION
              </Button>
            )}

            <Button
              style={{ backgroundColor: '#00acc1', color: '#FFF' }}
              onClick={() => openChat('destination')}
            >
              OPEN DESTINATION CHAT
            </Button>
          </Grid>
          {chat && (
            <React.Fragment>
              {openChats.indexOf('destination') > -1 && (
                <Chat orderID={orderID} channel="destination" />
              )}
            </React.Fragment>
          )}
        </div>
      </Grid>

      <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
        <Divider orientation="horizontal" variant="fullWidth" />
      </Grid>

      <Grid item xs={12}>
        <div>
          <Grid item xs={12}>
            {thirdParty && (
              <div>
                <br />
                <h4>
                  <b>Third Party</b>
                </h4>
                <p>
                  <b>
                    {billingParty == 'Third Party' && (
                      <div style={{ color: 'green', display: 'inline' }}>
                        ${' '}
                      </div>
                    )}
                    {thirdParty['businessName']} KSMS:{' '}
                    {thirdParty['ksms'] ? 'TRUE' : 'FALSE'}
                    <br />
                    {thirdParty['entityID']}
                  </b>
                </p>
                <p>
                  {thirdParty['referenceID'] && ` ${thirdParty['referenceID']}`}
                </p>
                {thirdParty['businessName'] !== 'CargoRX' && (
                  <div>
                    <p>
                      {thirdParty['address']} {thirdParty['city']}{' '}
                      {thirdParty['state']} {thirdParty['zip']}
                    </p>
                    <p>
                      {`${thirdParty['firstName']} ${thirdParty['lastName']}`} |{' '}
                      {thirdParty['phone']} | {thirdParty['email']}
                    </p>
                  </div>
                )}
              </div>
            )}
          </Grid>

          <Grid item xs={12} style={{ display: 'flex' }}>
              <React.Fragment>
                <Button
                  style={{
                    backgroundColor: '#00acc1',
                    color: '#FFF',
                    marginRight: 15,
                    maxHeight: 40,
                  }}
                  onClick={() => handleClickOpen('updateThirdParty')}
                >
                  EDIT THIRD PARTY
                </Button>
                {isEditable && thirdParty && (

                <Button
                  style={{
                    backgroundColor: '#00acc1',
                    color: '#FFF',
                    maxHeight: 40,
                  }}
                  onClick={() => openChat('thirdParty')}
                >
                  OPEN THIRD PARTY CHAT
                </Button>
                            )}
              </React.Fragment>
          </Grid>
          {chat && (
            <React.Fragment>
              {openChats.indexOf('thirdParty') > -1 && (
                <Chat orderID={orderID} channel="thirdParty" />
              )}
            </React.Fragment>
          )}
        </div>
      </Grid>

      <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
        <Divider orientation="horizontal" variant="fullWidth" />
      </Grid>

      <Grid item xs={12}>
        <div>
          <Grid item xs={6}>
            <h4 style={{ fontSize: '1rem' }}>
              <b>Freight Information</b>
            </h4>
            <p>
              <b>Total weight: {totalWeight}</b>
            </p>
          </Grid>

          <Grid item xs={12}>
            {items.map((item, i) => {
              return (
                <Grid container key={i}>
                  <Grid item xs={12}>
                    <p>
                      <b>Item # {i + 1}</b>
                    </p>
                  </Grid>
                  {item['isHazmat'] ? (
                    <Grid item xs={12}>
                      <Grid container>
                        <Grid item xs={4}>
                          <p>UN Number: {item.unNumber}</p>
                        </Grid>
                        <Grid item xs={4}>
                          <p>Proper Shipping Name: {item.properShippingName}</p>
                        </Grid>
                        <Grid item xs={4}>
                          <p>
                            Emergency Response Number:{' '}
                            {item.emergencyResponseNumber}
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}

                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={4}>
                        <p>Packaging: {item.packaging}</p>
                      </Grid>
                      <Grid item xs={4}>
                        <p>Quantity: {item.quantity}</p>
                      </Grid>
                      <Grid item xs={4}>
                        <p>Weight: {item.weight}</p>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={4}>
                        <p>Length: {item.length}</p>
                      </Grid>
                      <Grid item xs={4}>
                        <p>Width: {item.width}</p>
                      </Grid>
                      <Grid item xs={4}>
                        <p>Height: {item.height}</p>
                      </Grid>
                    </Grid>
                    <Grid container>
                      {item.files &&
                        item.files.map((file, i) => {
                          return (
                            <Grid item xs={4} key={i}>
                              <img src={file.picURL} width="100px" />
                            </Grid>
                          );
                        })}
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    {item['isBrokenDown'] ? (
                      <Grid container>
                        <Grid item xs={4}>
                          <p>Description: {item.description}</p>
                        </Grid>
                        <Grid item xs={4}>
                          Declared Value: ${item.declaredValue}
                        </Grid>
                        <Grid item xs={4}>
                          <p>Item can be broken down</p>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid container>
                        <Grid item xs={4}>
                          <p>Description: {item.description}</p>
                        </Grid>
                        <Grid item xs={4}>
                          Declared Value: ${item.declaredValue}
                        </Grid>
                      </Grid>
                    )}
                  </Grid>

                  {item['class'] ? (
                    <Grid item xs={12}>
                      <p>Freight Class: {item['class']}</p>
                    </Grid>
                  ) : null}
                </Grid>
              );
            })}
          </Grid>

          <Grid item xs={12}>
            {isEditable && (
              <Grid item xs={12}>
                <Grid container>
                  <Button
                    style={{ backgroundColor: '#00acc1', color: '#FFF' }}
                    onClick={() => handleClickOpen('updateFreight')}
                  >
                    EDIT FREIGHT
                  </Button>
                </Grid>
              </Grid>
            )}

            {isEditable && (
              <Grid container>
                <Dialog
                  style={{ height: 'auto' }}
                  open={updateOrigin}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={() => handleClose('updateOrigin')}
                  aria-labelledby="shipment-modal-slide-title"
                  aria-describedby="shipment-modal-slide-description"
                >
                  <DialogContent>
                    <ModalEditPartyDateDetails
                      arr={origin}
                      billingParty={billingParty}
                      businessQuery={businessQuery}
                      userQuery={userQuery}
                      errorMessage={errorMessage}
                      classes={classes}
                      assignBusiness={assignBusiness}
                      assignUser={assignUser}
                      arrString={'origin'}
                      locationType={true}
                      handleChange={handleChange}
                      handleSelectChange={handleSelectChange}
                      handleArrChange={handleArrChange}
                      handleSelectChangeObj={handleSelectChange}
                      handleDateChange={handleDateChange}
                      handleToggleServices={handleToggleServices}
                      handleNotificationsToggle={handleNotificationsToggle}
                      saveInfo={saveInfo}
                    />
                    <Button
                      style={{ float: 'right', marginTop: '20px' }}
                      color="primary"
                      onClick={() => saveInfo('origin')}
                    >
                      SAVE
                    </Button>
                  </DialogContent>
                </Dialog>
                <Dialog
                  style={{ height: 'auto' }}
                  open={updateDestination}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={() => handleClose('updateDestination')}
                  aria-labelledby="shipment-modal-slide-title"
                  aria-describedby="shipment-modal-slide-description"
                >
                  <DialogContent>
                    <ModalEditPartyDateDetails
                      arr={destination}
                      billingParty={billingParty}
                      businessQuery={businessQuery}
                      userQuery={userQuery}
                      errorMessage={errorMessage}
                      classes={classes}
                      assignBusiness={assignBusiness}
                      assignUser={assignUser}
                      arrString={'destination'}
                      locationType={true}
                      handleChange={handleChange}
                      handleSelectChange={handleSelectChange}
                      handleArrChange={handleArrChange}
                      handleSelectChangeObj={handleSelectChange}
                      handleDateChange={handleDateChange}
                      handleNotificationsToggle={handleNotificationsToggle}
                      handleToggleServices={handleToggleServices}
                      saveInfo={saveInfo}
                    />
                    <Button
                      style={{ float: 'right', marginTop: '20px' }}
                      color="primary"
                      onClick={() => saveInfo('destination')}
                    >
                      SAVE
                    </Button>
                  </DialogContent>
                </Dialog>
                <Dialog
                  style={{ height: 'auto' }}
                  open={updateThirdParty}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={() => handleClose('updateThirdParty')}
                  aria-labelledby="shipment-modal-slide-title"
                  aria-describedby="shipment-modal-slide-description"
                >
                  <DialogContent>
                    <ModalPartyDetails
                      arr={thirdParty}
                      billingParty={billingParty}
                      businessQuery={businessQuery}
                      userQuery={userQuery}
                      classes={classes}
                      assignBusiness={assignBusiness}
                      assignUser={assignUser}
                      arrString={'thirdParty'}
                      locationType={false}
                      handleChange={handleChange}
                      handleSelectChange={handleSelectChange}
                      handleArrChange={handleArrChange}
                      handleSelectChangeObj={handleSelectChange}
                      handleNotificationsToggle={handleNotificationsToggle}
                      handleToggleServices={handleToggleServices}
                    />

                    <Button
                      style={{ float: 'right', marginTop: '20px' }}
                      color="primary"
                      onClick={() => saveInfo('thirdParty')}
                    >
                      SAVE
                    </Button>
                  </DialogContent>
                </Dialog>
                <Dialog
                  style={{ height: 'auto' }}
                  open={updateFreight}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={() => handleClose('updateFreight')}
                  aria-labelledby="shipment-modal-slide-title"
                  aria-describedby="shipment-modal-slide-description"
                >
                  <DialogContent>
                    <Items
                      items={items}
                      itemCount={itemCount}
                      errorMessage={errorMessage}
                      classes={classes}
                      addItem={addItem}
                      removeItem={removeItem}
                      handleItemChange={handleItemChange}
                      handleItemSelectChange={handleItemSelectChange}
                      handleToggleItemServices={handleToggleItemServices}
                      handleSelectChangeObj={handleSelectChange}
                      handleToggleServices={handleToggleServices}
                      onAssignPic={onAssignPic}
                      removePicture={removePicture}
                      toggleFootage={toggleFootage}
                    />

                    <Button
                      style={{ float: 'right', marginTop: '20px' }}
                      color="primary"
                      onClick={() => saveFreight()}
                    >
                      SAVE
                    </Button>
                  </DialogContent>
                </Dialog>
              </Grid>
            )}
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
};

export default PartyFreightSummary;


// WEBPACK FOOTER //
// ./src/components/Forms/PartyFreightSummary.jsx